// extracted by mini-css-extract-plugin
export default {"name-value-pair":"NameValuePair_name-value-pair__zdPCi"};